var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBj = function SvgIconBj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m7.826 10.957 1.044 12.63c.998.269 2.047.413 3.13.413 6.627 0 12-5.372 12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.826 12 8.87.414A12 12 0 0 1 12 0c6.627 0 12 5.373 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M0 12c0 5.544 3.76 10.21 8.87 11.586V.413C3.76 1.79 0 6.455 0 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconBj;